<template>
    <v-container class="fill-height pa-0 d-flex flex-row align-content-space-between justify-center">
        <v-avatar width="140px"
                  height="auto"
                  tile
                  class="logo mb-3">
            <v-img class="align-self-start"
                   width="100%"
                   :aspect-ratio="4/3"
                   contain
                   src="../assets/images/logo_small.svg"></v-img>
        </v-avatar>

        <router-view/>
    </v-container>
</template>
<script>
    export default {
        name: 'auth',
    }
</script>
